// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"GListSkeleton-module_skeletonContainer_e0727176"};